import React, { createContext, Dispatch } from "react"
import { ImportacaoClientesActions } from "./importacaoClientesActions"
import { ImportacaoClientesInicial, ImportacaoClientesModel } from "../models/importacaoClientesModel"

interface ImportacaoClientesContextType {
    dados: ImportacaoClientesModel
    dispatch: Dispatch<ImportacaoClientesActions>
}

export const ImportacaoClientesContext = createContext<ImportacaoClientesContextType>({
    dados: ImportacaoClientesInicial,
    dispatch: () => undefined,
})
